// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__2zNbN","productName":"Table_productName__3rqqM"};